import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { RichTextDSWidget } from './rich-text-ds-widget'
import { RichTextWidgetLegacy } from './rich-text-widget-legacy'

import type { RichTextWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

const RichTextWidgetComponent = (props: PLTypedWidgetProps<RichTextWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <RichTextDSWidget {...props} />
  }
  return <RichTextWidgetLegacy {...props} />
}

export const RichTextWidget: PLTypedWidgetInterface<RichTextWidgetData, WidgetType.RICH_TEXT> = {
  id: WidgetType.RICH_TEXT,
  errorBoundary: PLBaseErrorBoundary,
  render: RichTextWidgetComponent,
}
